import React from 'react';
import Container from "@mui/material/Container";
import {Grid, Typography} from "@mui/material";

export default () =>
    <Container maxWidth="lg">
        <Grid container>
            <Grid item md={12}>
                <Typography variant='h4' align='center' p={5}>
                    Su suscripción se encuentra en proceso de revisión.
                    En cuanto sea aprobada, recibirá un correo electrónico de confirmación, pudiendo ingresar así a la plataforma
                </Typography>
            </Grid>
        </Grid>
    </Container>